// extracted by mini-css-extract-plugin
export default {"box":"cancellationFilterPage_box__wuAJy","box__content":"cancellationFilterPage_box__content__-m7w5"};